export let currentFolderScope = "tN3fuc";
export let recursiveFolderScope = "iYLled";
export let allMailboxesScope = "$DT9Se";
export let allPstFilesScope = "hjrfse";
export let favoritesFolderScope = "vN9ucb";
export default {currentFolderScope,recursiveFolderScope,allMailboxesScope,allPstFilesScope,favoritesFolderScope};